var _style, _path, _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#338AF3;}\n\t.st1{fill:#0052B4;}\n\t.st2{fill:#F0F0F0;}\n\t.st3{fill:#D80027;}\n\t.st4{fill:#FFDA44;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512,256c0,141.4-114.6,256-256,256C114.6,512,0,397.4,0,256C0,256.1,256,0,256,0C397.4,0,512,114.6,512,256z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.4,256h86.3l-75.2-89l-11.1,33.4L122.4,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,208.8l-89-86.3h89L256,208.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256,0C256,0,256,0,256,0L256,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M255.3,256h0.7c0-0.2,0-0.5,0-0.7C255.8,255.5,255.5,255.8,255.3,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256,133.6c0-45,0-74.6,0-133.6h0C114.6,0,0,114.6,0,256h133.6v-75.2l75.2,75.2h46.5c0.2-0.2,0.5-0.5,0.7-0.7 c0-17.2,0-32.6,0-46.5l-75.2-75.2H256z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M129.5,33.4c-40,22.8-73.3,56.1-96.1,96.1V256h66.8V100.2v0H256c0-21.1,0-41.1,0-66.8H129.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M256,224.5l-91-91h-31.5v0L256,256h0C256,256,256,234.3,256,224.5z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M279.4,423l5.5,17h17.9l-14.5,10.5l5.5,17L279.4,457l-14.5,10.5l5.5-17L256,440h17.9L279.4,423z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M421.8,311.7l5.5,17h17.9l-14.5,10.5l5.5,17l-14.5-10.5l-14.5,10.5l5.5-17l-14.5-10.5h17.9L421.8,311.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M457.5,144.7l5.5,17h17.9l-14.5,10.5l5.5,17l-14.5-10.5L443,189.2l5.5-17l-14.5-10.5H452L457.5,144.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M466.3,267.1l5.5,17h17.9l-14.5,10.5l5.5,17l-14.5-10.5l-14.5,10.5l5.5-17l-14.5-10.5h17.9L466.3,267.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M305,383l15.9,8.1l12.6-12.6l-2.8,17.7l15.9,8.1l-17.7,2.8l-2.8,17.7l-8.1-15.9l-17.7,2.8l12.6-12.6L305,383z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M305,316.2l15.9,8.1l12.6-12.6l-2.8,17.7l15.9,8.1l-17.7,2.8l-2.8,17.7l-8.1-15.9l-17.7,2.8l12.6-12.6 L305,316.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M360.7,359l15.9,8.1l12.6-12.6l-2.8,17.7l15.9,8.1l-17.7,2.8l-2.8,17.7l-8.1-15.9l-17.7,2.8l12.6-12.6 L360.7,359z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M360.7,216l15.9,8.1l12.6-12.6l-2.8,17.7l15.9,8.1l-17.7,2.8l-2.8,17.7l-8.1-15.9l-17.7,2.8l12.6-12.6 L360.7,216z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M414.6,214.3l15.9,8.1l12.6-12.6l-2.8,17.7l15.9,8.1l-17.7,2.8l-2.8,17.7l-8.1-15.9l-17.7,2.8l12.6-12.6 L414.6,214.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.6153083528f8afd9d6b070fa8d8bee69.svg";
export { ForwardRef as ReactComponent };